import { render, staticRenderFns } from "./PropertyBook.vue?vue&type=template&id=4ee64b7e&scoped=true"
import script from "./PropertyBook.vue?vue&type=script&lang=js"
export * from "./PropertyBook.vue?vue&type=script&lang=js"
import style0 from "./PropertyBook.vue?vue&type=style&index=0&id=4ee64b7e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee64b7e",
  null
  
)

export default component.exports